import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {SessionService} from "src/app/services/session.service";
import {toastrService} from "src/app/services/ux/toastr.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MailItemHttpClientService} from "../../data/mailItem-http-client.service";
import {finalize} from "rxjs/operators";
import {MailItem} from "../../models/Tracking/mail-item.model";
import {HttpErrorResponse} from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
@Component({
    templateUrl: "./tracking-component.component.html"
})
export class TrackingComponent implements OnInit {
    loading = true;
    isLoading = false;
    savedTrackCodes = [] as Array<MailItem>;


    trackForm = new FormGroup({
        barcode:
            new FormControl
            ("",
                [
                    Validators.required,
                    Validators.minLength(13),
                    Validators.maxLength(13)
                ]
            ),
        description: new FormControl("", [Validators.required]),
        shouldNotify: new FormControl(true, [Validators.required]),
    });


    constructor(
        public toastr: toastrService,
        public router: Router,
        public session: SessionService,
        private http: MailItemHttpClientService,
        private translateService: TranslateService
    ) {
    }

    ngOnInit() {
        if (this.session.isLoggedIn()) {
            this.getMailItems();
        } else {
            this.loading = false;
        }
    }

    getTrackData() {
        // Check if code has proper length
        if (typeof this.trackForm.value.barcode === "undefined" ||
            this.trackForm.value.barcode.length !== 13) {
            return this.toastr.error(this.translateService.instant("Tracking.CodeMustBe13"));
        }

        this.router.navigate(["/tracking/", this.trackForm.value.barcode]);
    }

    getMailItems() {
        this.isLoading = true;
        this.loading = true;

        this.http.getMailItems()
            .pipe(
                finalize(
                    () => {
                        this.isLoading = false;
                        this.loading = false;
                    }
                )
            )
            .subscribe(
                {
                    next: mailItems => {
                        console.log("MailItems: ", mailItems);
                        this.savedTrackCodes = mailItems;

                        // mailItems.forEach(mailItem => {
                        //     this.getDetailsMailItem(mailItem.itemCode);
                        // });
                    },
                    error: err => {
                        this.toastr.error(err);
                    }
                }
            );
    }

    saveMailItem() {
        this.isLoading = true;

        if (!this.trackForm.valid) {
            this.isLoading = false;
            return this.toastr.error(this.translateService.instant("Tracking.BarcodeMustBe13"));
        }

        const trackingObj = {
            barcode: this.trackForm.value.barcode as string,
            itemName: this.trackForm.value.description as string,
            notification: this.trackForm.value.shouldNotify as boolean
        };

        this.http.postMailItems(trackingObj).pipe(
            finalize(
                () => {
                    this.isLoading = false;
                }
            )
        ).subscribe(
            {
                next: res => {
                    console.log("Tracking Component: ", res);
                    this.toastr.success(this.translateService.instant("Tracking.PackageSaved"));
                    this.getMailItems();
                    this.trackForm.reset();
                },
                error: err => {
                    console.error("Tracking Component: ", err);
                    if ((err.error = "barcode_exists_in_user_profile")) {
                        this.toastr.warning(this.translateService.instant("Tracking.BarcodeStored"));
                    } else {
                        this.toastr.error(err);
                    }
                }
            }
        );
    }

    deleteMailItem(itemId: number) {
        this.http.deleteMailItem(itemId).subscribe(
            {
                next: (res: string) => {
                    if (res === "success") {
                        this.toastr.success(this.translateService.instant("Tracking.PackageDeleted", { itemId }));

                        const index = this.savedTrackCodes.findIndex(
                            (mailItem) => {
                                return mailItem.itemId === itemId;
                            }
                        );
                        this.savedTrackCodes.splice(index, 1);
                    } else {
                        this.toastr.error(res);
                    }
                },
                error: (err: HttpErrorResponse) => {
                    this.toastr.error(err.error);
                }
            }
        );
    }

    getDetailsMailItem(barcode: string) {

        this.http.getMailItemDetails(barcode)
            .subscribe(
                {
                    next: (mailItemEvent) => {
                        console.log("Events: ", mailItemEvent);
                    }
                }
            );
        // this.client
        //     .get(apiStr)
        //
        //     // Get response and attach property details to the codes array
        //     .then((res: any) => {
        //         if (res === "Pakoja nuk ekziston") {
        //             code.details = res;
        //         } else if (res.length === 0) {
        //             code.details = "Nuk ka asnje ngjarje per kete barkod";
        //         } else {
        //             code.details = res[res.length - 1].description;
        //         }
        //     })
        //
        //     // Catch errors
        //     .catch((err: any) => {
        //         if (err === "package_not_found") {
        //             code.details = "Pakoja nuk u gjet!";
        //         }
        //
        //         return err;
        //     });
    }
}
